import { render, staticRenderFns } from "./Medallas_editar.vue?vue&type=template&id=bf6d4efe"
import script from "./Medallas_editar.vue?vue&type=script&lang=js"
export * from "./Medallas_editar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports